export default "__VITE_ASSET__8db726c1__"